// Shop/Category page layout button

jQuery(document).on('click', '#two-column-btn', function() { 
    jQuery('.view-toggle button').removeClass('active_toggle_btn');
    jQuery(this).addClass('active_toggle_btn');
    jQuery('.product-grid-container')
        .removeClass('three_column list_column shape_column')
        .addClass('two_column');
});

jQuery(document).on('click', '#list-column-btn', function() { 
    jQuery('.view-toggle button').removeClass('active_toggle_btn');
    jQuery(this).addClass('active_toggle_btn');
    jQuery('.product-grid-container')
        .removeClass('three_column two_column shape_column')
        .addClass('list_column');
});

jQuery(document).on('click', '#shape-column-btn', function() { 
    jQuery('.view-toggle button').removeClass('active_toggle_btn');
    jQuery(this).addClass('active_toggle_btn');
    jQuery('.product-grid-container')
        .removeClass('three_column two_column list_column')
        .addClass('shape_column');
});

jQuery(document).on('click', '#three-column-btn', function() {   
    jQuery('.view-toggle button').removeClass('active_toggle_btn');
    jQuery(this).addClass('active_toggle_btn');
    jQuery('.product-grid-container')
        .removeClass('two_column list_column shape_column')
        .addClass('three_column');
});


// Home page Slider
jQuery("#Slider-template--24090598277441__featured_collection_FY7RTX").slick({
  slidesToShow: 3, 
  slidesToScroll: 1,
  infinite: true, // Enables infinite looping
  autoplay: false, // Enables autoplay
  dots: true, // Adds dots for this breakpoint
  autoplaySpeed: 2000, // Sets autoplay speed (2 seconds)
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});



// Home page read more
$('.readmore_content').hide(); // Hide content initially

    $('.readmore_content_btn').click(function () {
        var content = $(this).prev('.readmore_content');
        content.slideToggle(); // Toggle content visibility

        // Toggle button text
        $(this).text(function (_, currentText) {
            return currentText.trim() === 'More' ? 'Less' : 'More';
        });
    });


// Home page Load More
$('#Slider-template--24090598277441__featured_collection_gTMDkE li.grid__item:gt(7)').hide();

// Click event handler for the Load More button
$('.bestseller_loadmore').on('click', function(e) {
    e.preventDefault();
    // Show the next 4 hidden li elements
    $('#Slider-template--24090598277441__featured_collection_gTMDkE .grid__item:hidden').slice(0, 8).slideDown();
    // Hide the Load More button if there are no more hidden li elements
    if ($('#Slider-template--24090598277441__featured_collection_gTMDkE .grid__item:hidden').length === 0) {
        $('.bestseller_loadmore').hide();
    }
});



function synchronizeActiveClasses(activeIndex) {
    $('.thumbnail-list li').removeClass('active');
    $('.product__media-list li').removeClass('is-active');
    if (activeIndex !== -1) {
        $('.thumbnail-list li').eq(activeIndex).addClass('active');
        $('.product__media-list li').eq(activeIndex).addClass('is-active');
    }
}

var initialActiveIndex = $('.product__media-list li.is-active').index();
synchronizeActiveClasses(initialActiveIndex);

$(document).on('click', '.thumbnail-list li', function () {
    var clickedIndex = $(this).index();
    synchronizeActiveClasses(clickedIndex);
});



if (window.matchMedia("(max-width: 1024px)").matches && $('#two-column-btn').length) {
    setTimeout(function () {
        $('#two-column-btn').trigger('click');
    }, 1000);
}
$(document).ready(function() {
  $('#read-more-btn').click(function() {
    // Adjust scroll position for sticky navbar height (100px)
    var navbarHeight = 200;  // Set navbar height to 100px

    // Scroll smoothly to the #additional-info-footer section, adjusting for the navbar
    $('html, body').animate({
      scrollTop: $('#additional-info-footer').offset().top - navbarHeight
    }, 1000);  // Adjust 1000 for scrolling speed (in milliseconds)
  });
});
